// src/portal-app/nav/tabs.js
//
// The Aqana Manager nav map (F12b Task 6) — single source of truth for the
// adaptive shell's 5 tabs and the hub screens behind them. Plain data, no
// React: `icon` is a string key rendered by PortalShell's inline-SVG icon set,
// and every user-visible string is a translation key with an English fallback
// consumed as t(labelKey, {}, fallback).
//
//   TABS — ordered array of exactly 5: home, insights, operations, team, more.
//   HUBS — map keyed by tab id (except `home`, which renders HomeTab) →
//          { titleKey, titleFallback, cards: [{ id, labelKey, fallback,
//            sectionKey?, sectionFallback? }] }.
//
// Consecutive cards sharing a `sectionKey` render under a small section label
// in HubScreen (the More hub's "Catalogue" group).
//
// Gating fields (W2 Task 4) — semantics mirror the web PortalLayout exactly:
//   permission? — portal permission key (NAV_PERMISSION_MAP values). The card
//                 is HIDDEN when useAuth().hasPermission(key) is false.
//                 AuthContext preserves the legacy fallback: a user with zero
//                 loaded permissions is allowed everything.
//   feature?    — plan feature flag (NAV_FEATURE_MAP values). When
//                 useAuth().hasFeature(flag) is false the card STILL RENDERS,
//                 in a locked/upsell state (not tappable, does not push).
// A card id present in nav/routes.js ROUTES becomes a tappable button that
// pushes that route; absent ids stay inert until their screen is built.

export const TABS = [
    { id: 'home', labelKey: 'tab_home', icon: 'home', fallback: 'Home' },
    { id: 'insights', labelKey: 'tab_insights', icon: 'insights', fallback: 'Insights' },
    { id: 'operations', labelKey: 'tab_operations', icon: 'operations', fallback: 'Operations' },
    { id: 'team', labelKey: 'tab_team', icon: 'team', fallback: 'Team' },
    { id: 'more', labelKey: 'tab_more', icon: 'more', fallback: 'More' },
];

export const HUBS = {
    insights: {
        titleKey: 'tab_insights',
        titleFallback: 'Insights',
        cards: [
            // permission/feature values match the web PortalLayout maps:
            // NAV_PERMISSION_MAP.reporting / NAV_FEATURE_MAP.reporting.
            { id: 'financial', labelKey: 'hub_financial_performance', fallback: 'Financial Performance', permission: 'portal:reporting', feature: 'analytics' },
            { id: 'operational', labelKey: 'hub_operational_efficiency', fallback: 'Operational Efficiency', permission: 'portal:reporting', feature: 'analytics' },
            { id: 'product', labelKey: 'hub_product_intelligence', fallback: 'Product Intelligence', permission: 'portal:reporting', feature: 'analytics' },
            { id: 'cost', labelKey: 'hub_cost_management', fallback: 'Cost Management', permission: 'portal:reporting', feature: 'analytics' },
        ],
    },
    operations: {
        titleKey: 'tab_operations',
        titleFallback: 'Operations',
        cards: [
            { id: 'transactions', labelKey: 'hub_transactions', fallback: 'Transactions', permission: 'portal:reporting' },
            { id: 'reservations', labelKey: 'hub_reservations', fallback: 'Reservations', permission: 'portal:overview', feature: 'reservations' },
            { id: 'expenses', labelKey: 'hub_expenses', fallback: 'Expenses', permission: 'portal:expenses', feature: 'expenses' },
            { id: 'eod', labelKey: 'hub_end_of_day', fallback: 'End of Day' },
        ],
    },
    team: {
        titleKey: 'tab_team',
        titleFallback: 'Team',
        cards: [
            { id: 'employees', labelKey: 'hub_employees', fallback: 'Employees', permission: 'portal:employees', feature: 'hr' },
            { id: 'schedule', labelKey: 'hub_schedule', fallback: 'Schedule', permission: 'portal:schedule', feature: 'hr' },
            { id: 'payruns', labelKey: 'hub_pay_runs', fallback: 'Pay Runs', permission: 'portal:payroll', feature: 'hr' },
        ],
    },
    more: {
        titleKey: 'tab_more',
        titleFallback: 'More',
        cards: [
            {
                id: 'products',
                labelKey: 'hub_products',
                fallback: 'Products',
                sectionKey: 'hub_catalogue',
                sectionFallback: 'Catalogue',
                permission: 'portal:products',
            },
            {
                id: 'inventory',
                labelKey: 'hub_inventory',
                fallback: 'Inventory',
                sectionKey: 'hub_catalogue',
                sectionFallback: 'Catalogue',
                permission: 'portal:inventory',
                feature: 'inventory',
            },
            { id: 'marketing', labelKey: 'hub_marketing', fallback: 'Marketing', permission: 'portal:marketing', feature: 'marketing' },
            { id: 'settings', labelKey: 'hub_settings', fallback: 'Settings', permission: 'portal:settings' },
            { id: 'devices', labelKey: 'hub_devices', fallback: 'Devices', permission: 'portal:devices', feature: 'devices_multi' },
            { id: 'help', labelKey: 'hub_help', fallback: 'Help', permission: 'portal:overview' },
            { id: 'account', labelKey: 'hub_account', fallback: 'Account' },
            { id: 'roles', labelKey: 'hub_roles', fallback: 'Roles', permission: 'portal:roles', feature: 'team_access' },
        ],
    },
};
